<template>
  <!-- Add a ref named "scrollContainer" -->
  <div
    ref="scrollContainer"
    class=""
  >
    <ChatMessage
      v-for="(message, i) in chatStore.conversations?.[chatStore.currentConversationId]?.messages"
      :key="i"
      :message="message"
    />
    <ChatMessage :message="chatStore.conversations?.[chatStore.currentConversationId]?.streamingMessage" />

    <!-- Tool activity spinner row -->
    <div v-if="chatStore.toolActivityCount > 0" class="tw-px-6 tw-py-4 tw-flex tw-items-center tw-gap-2">
      <i class="fas fa-spinner fa-spin tw-mr-1"></i>
      <span class="tw-text-gray-600">
        {{ chatStore.lastToolDescription || 'Working' }}…
      </span>
    </div>
  </div>
</template>

<script>
import ChatMessage from '@frontend/ui/features/chat/components/ChatMessage.vue';
import { mapStores } from 'pinia';
import { useChatStore } from '@frontend/ui/stores/chatStore';

export default {
  name: 'ChatMessagesBox',
  components: { ChatMessage },
  props: [/* Inputs */],
  data() {
    return {

    };
  },
  computed: {
    ...mapStores(useChatStore),
  },
  mounted() {
    // Scroll to the bottom when the component is mounted
    this.scrollToBottom();
  },
  updated() {
    // Scroll to the bottom whenever the component updates
    this.scrollToBottom();
  },
  methods: {
    // Method to scroll the container to the bottom
    scrollToBottom() {
      this.$refs.scrollContainer.scrollTop = this.$refs.scrollContainer.scrollHeight;

      // Would like to only autoscroll if the user is already at the bottom
      // But couldn't get it to work. These are some of our debugging efforts.
      /*
      console.log('scrollToBottom')
      const container = this.$refs.scrollContainer;
      const distanceToBottom = (container.scrollHeight - container.clientHeight) - container.scrollTop
      console.log('distanceToBottom', distanceToBottom)
      console.log('scrollHeight', container.scrollHeight)
      console.log('clientHeight', container.clientHeight)
      console.log('scrollTop', container.scrollTop)
      */
    },
  },
};
</script>

<style scoped>

@keyframes stk_spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.stk-spinner {
  animation: stk_spin 1s linear infinite;
}

</style>
